import type { VehiclePosition, VehiclePositionsDelta } from './index';

export function applySnapshot(vehicles: Map<string, VehiclePosition>, snapshot: VehiclePosition[]): void {
  vehicles.clear();
  for (const v of snapshot) vehicles.set(v.vehicleId, v);
}

export function applyDelta(vehicles: Map<string, VehiclePosition>, delta: VehiclePositionsDelta): void {
  for (const v of delta.updated) vehicles.set(v.vehicleId, v);
  for (const id of delta.removed) vehicles.delete(id);
}
